/*
 *   File : badge.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : badge
 *   Version : 1.0.0
 *   Created : 08-12-2021
 */

import React from 'react';

/*import styles*/
import styles from '../../styles/components/badge.module.scss';

export default function Tooltip(props) {
	return (
		<>
			<div className={`${styles.e_tool_tip} ${props.className}`}>
				{props.content}
			</div>
		</>
	);
}